<!--
 * @Description: 企业实名信息核验组件
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2026-05-21
 * @LastEditors: zhangle
 * @LastEditTime: 2026-05-21
-->
<template>
    <div class="tsa-companyRealNameInfoVerify" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="title-top">
                <h4>企业信息核验</h4>
                <img @click="close" src="/static/img/icon/close.png" alt="">
            </div>
            <div class="scroll">
                <div class="form">
                    <div class="item">
                        <p class="name">名称</p>
                        <div class="value disabled">
                            <input v-model="enterpriseName" readonly type="text" placeholder="请输入企业名称">
                        </div>
                    </div>
                    <div class="item">
                        <p class="name">证件号</p>
                        <div class="value disabled">
                            <input v-model="enterpriseCreditCode" readonly type="text" placeholder="请输入证件号">
                        </div>
                    </div>
                    <div class="item">
                        <p class="name">法定代表人</p>
                        <div class="value">
                            <input v-model="legalRepName" type="text" placeholder="请输入法定代表人姓名">
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="btn" @click="close">
                    <p>取消</p>
                </div>
                <div class="btn confirm" @click="confirm">
                    <p>提交</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { signVerificationUserInfoApi, signVerifyBusinessApi } from '@/api/common'
import { setBodyOverflow } from '@/js/utils'
import NoTrace from '@/js/noTrace';
export default {
    name: 'TsaCompanyRealNameInfoVerify',
    data () {
        return {
            show: false,
            enterpriseCreditCode: '',
            enterpriseName: '',
            legalRepName: '',
            // 经办人核验返回的临时记录ID（tempVerificationId）
            verificationId: '',
            // 合同ID
            contractId: '',
            // 签署会话ID
            signSessionId: '',
            // 经办人姓名
            operatorName: '',
            // 经办人身份证号
            operatorIdCard: '',
            // 经办人手机号
            operatorPhone: '',
        }
    },
    watch: {
        show (val) {
            setBodyOverflow(val)
            if (!val) {
                this.enterpriseCreditCode = ''
                this.enterpriseName = ''
                this.legalRepName = ''
                this.verificationId = ''
                this.contractId = ''
                this.signSessionId = ''
                this.operatorName = ''
                this.operatorIdCard = ''
                this.operatorPhone = ''
            }
        }
    },
    methods: {
        init () {
            this.$TsaLoading.show()
            signVerificationUserInfoApi().then((res) => {
                this.$TsaLoading.hide()
                if (res.code == '0') {
                    this.show = true
                    this.enterpriseCreditCode = res.data.creditCode
                    this.enterpriseName = res.data.enterpriseName
                }
            }).catch((err) => {
                this.$TsaLoading.hide()
            });
        },
        close () {
            this.show = false
        },
        confirm () {
            let legalRepName = this.legalRepName.trim()
            if (!legalRepName) {
                this.$toast('请输入法定代表人姓名')
                return
            }
            // 人机校验
            NoTrace.start({
                success: (nvc) => {
                    this.$TsaLoading.show()
                    signVerifyBusinessApi({
                        verificationId: this.verificationId,
                        contractId: this.contractId,
                        signSessionId: this.signSessionId,
                        operatorName: this.operatorName,
                        operatorIdCard: this.operatorIdCard,
                        operatorPhone: this.operatorPhone,
                        enterpriseName: this.enterpriseName,
                        enterpriseCreditCode: this.enterpriseCreditCode,
                        legalRepName,
                        nvc
                    }).then((res) => {
                        this.$TsaLoading.hide()
                        if (res.code == '0') {
                            this.show = false
                            this.onConfirm && this.onConfirm({
                                // 核验记录ID（与传入值相同，更新已有临时记录）
                                verificationId: res.data.verificationId,
                                enterpriseCreditCode: this.enterpriseCreditCode,
                                enterpriseName: this.enterpriseName,
                                legalRepName
                            })
                        }
                    }).catch(() => {
                        this.$TsaLoading.hide()
                    })
                },
                fail: () => {
                    console.log('fail')
                    this.$toast('人机校验失败')
                }
            })
            
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-companyRealNameInfoVerify {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        * {
            box-sizing: border-box;
        }
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
        }
        .content {
            display: flex;
            flex-direction: column;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            max-height: 95%;
            border-radius: 8px;
            background: #FFFFFF;
            border-radius: 16px 16px 0px 0px;
            .title-top {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;
                padding: 16px 20px 0 16px;
                h4 {
                   font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            .scroll {
                flex: 1;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                padding: 0 16px;
            }
            .form {
                .item {
                    margin-bottom: 24px;
                    .name {
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-bottom: 8px;
                    }
                    .value {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        background: #F7F9FD;
                        border-radius: 8px;
                        padding: 8px 12px;
                        border: 1px solid #F7F9FD;
                        &.disabled {
                            background: #EEF3F9;
                            border: 1px solid #CFDEF4;
                        }
                        input {
                            flex: 1;
                            font-size: 14px;
                            color: #333333;
                            border: 0;
                            outline: none;
                            -webkit-appearance: none;
                            appearance: none;
                            background-color: transparent;
                            &::placeholder {
                                font-size: 14px;
                                color: #666666;
                            }
                            &[readonly] {
                                -webkit-text-fill-color: #9FACBD;
                                color: #9FACBD;
                                
                            }
                        }
                        button {
                            font-size: 14px;
                            color: #0047FF;
                            border: 0;
                            outline: none;
                            background: transparent;
                            -webkit-appearance: none;
                            appearance: none;
                            padding: 0;
                            margin: 0;
                            cursor: pointer;
                            white-space: nowrap;
                            flex-shrink: 0;

                            &:disabled {
                                color: #999999;
                                cursor: not-allowed;
                            }
                        }
                    }
                }
            }
            .bottom {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                padding: 16px;
                box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
                .btn {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 162px;
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid #D9D9D9;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .confirm {
                    margin-left: 12px;
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    p {
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/companyRealNameInfoVerify/index.vue